import { TypeColor } from './types';

export const sizeX1Px = 4;
export const sizeX2Px = sizeX1Px * 2;
export const sizeX3Px = sizeX1Px * 3;
export const sizeX4Px = sizeX1Px * 4;
export const sizeX5Px = sizeX1Px * 5;
export const sizeX6Px = sizeX1Px * 6;
export const sizeX8Px = sizeX1Px * 8;
export const sizeX10Px = sizeX1Px * 10;
export const sizeX12Px = sizeX1Px * 12;
export const sizeX16Px = sizeX1Px * 16;
export const sizeX20Px = sizeX1Px * 20;

export const sizeX1Rem = sizeX1Px / 16;
export const sizeX2Rem = sizeX1Rem * 2;
export const sizeX3Rem = sizeX1Rem * 3;
export const sizeX4Rem = sizeX1Rem * 4;
export const sizeX5Rem = sizeX1Rem * 5;
export const sizeX6Rem = sizeX1Rem * 6;
export const sizeX8Rem = sizeX1Rem * 8;
export const sizeX10Rem = sizeX1Rem * 10;
export const sizeX12Rem = sizeX1Rem * 12;
export const sizeX16Rem = sizeX1Rem * 16;
export const sizeX20Rem = sizeX1Rem * 20;

export const borderSizeX1Px = 1;
export const borderSizeX2Px = 2;

export const transitionTimeFast = 200;
export const transitionTimeBase = 400;
export const transitionTimeSlow = 800;

export const transitionTimingFunction = [0.25, 0.46, 0.45, 0.94];

export const colorLight = '#ffffff';
export const colorLightGray = '#f2f2f2';
export const colorDarkGray = '#262626';
export const colorDark = '#261a17';
export const colorBlueLight = '#8970ff';
export const colorBlue = '#775eff';
export const colorBlueDark = '#6047ff';
export const colorRed = '#ff4258';

export const colorMap: Record<TypeColor, string> = {
  'light': colorLight,
  'light-gray': colorLightGray,
  'dark-gray': colorDarkGray,
  'dark': colorDark,
  'blue-light': colorBlueLight,
  'blue': colorBlue,
  'blue-dark': colorBlueDark,
  'red': colorRed,
};
